import { datadogRum } from '@datadog/browser-rum';

const datadogRumManager = {
  /**
   * Setup Datadog rum default config with any custom overrides
   * @param overrides
   */
  init: (overrides = {}) => {
    if (!overrides.applicationId || !overrides.clientToken) {
      return;
    }
    datadogRum.init(
      Object.assign(
        {
          applicationId: '',
          clientToken: '',
          service: '',
          env: '',
          version: '',
          site: 'datadoghq.com',
          beforeSend: function (event) {
            datadogRumManager.cleanEvent(event);
          },
          sessionSampleRate: 100,
          sessionReplaySampleRate: 20,
          defaultPrivacyLevel: 'mask',
          trackResources: true,
          trackLongTasks: true,
        },
        overrides,
      ),
    );
    datadogRum.startSessionReplayRecording();
  },
  /**
   * Calls populates this with areas needed cleaning - params, url etc
   */
  cleaners: {
    params: [],
  },
  /**
   * Check if an action name is a valid data-dd-action-name (kebab-case, no spaces or colons)
   * Our convention: [view]-[action] or [view]-[element]-[action] (e.g., "user-menu-sign-out")
   */
  isValidActionName: (actionName) => {
    if (!actionName || typeof actionName !== 'string') {
      return false;
    }
    // Valid action names use kebab-case with no spaces or colons
    return !actionName.includes(' ') && !actionName.includes(':');
  },
  /**
   * Sanitize action names to prevent PII from being sent to Datadog
   * If the action name doesn't follow our kebab-case convention, it's likely fallback text
   */
  sanitizeActionName: (event) => {
    if (event?.type === 'action' && event?.action?.target?.name) {
      const actionName = event.action.target.name;
      if (!datadogRumManager.isValidActionName(actionName)) {
        // Replace with a safe fallback
        event.action.target.name = 'unlabeled-element';
      }
    }
  },
  /**
   * Clean any sensitive info from requests before they're sent to Datadog
   */
  cleanEvent: (event) => {
    const cleaners = datadogRumManager.cleaners;
    const cleanString = function (string) {
      if (cleaners) {
        try {
          cleaners.params.length &&
            cleaners.params.forEach(function (s) {
              string = string.replace(
                new RegExp('(' + s + '=)[^&]+', 'ig'),
                '$1******',
              );
            });
        } catch (e) {
          string = 'error_sanitizing:' + e.toString();
        }
      }
      return string;
    };

    // Sanitize action names to prevent PII leakage
    datadogRumManager.sanitizeActionName(event);

    if (event?.resource?.url) {
      event.resource.url = cleanString(event.resource.url);
    }
    if (event?.error?.message) {
      event.error.message = cleanString(event.error.message);
    }
    if (event?.error?.stack) {
      event.error.stack = cleanString(event.error.stack);
    }
    if (event?.view?.url) {
      event.view.url = event.view.url.replace('/#', '');
    }
    return event;
  },
};

export default datadogRumManager;
